import React from 'react'
import { Link } from 'react-router-dom';
import Shape02 from '../../../assets/images/services/personal.png';
import Shape03 from '../../../assets/images/services/debt.png';
import Shape04 from '../../../assets/images/services/money-bag.png';
import Shape05 from '../../../assets/images/services/mortarboard.png';
import Shape06 from '../../../assets/images/services/mortgage-loan.png';
import Shape07 from '../../../assets/images/services/loan.png';


const Servicedata = [
    {
        Image: "flaticon-evaluate",
        
        heading: "1. Trust First",
        content: "We build relationships based on transparency, integrity, and accountability. Our clients rely on us to guide them through high-stakes decisions — and we never take that trust for granted."
    },
    {
        Image: "flaticon-expert",
    
        heading: "2. Client-Centric Service",
        content: "Every client is unique. We offer personalized, culturally sensitive solutions tailored to their needs, life stage, and long-term goals — never one-size-fits-all advice."
    },
    {
        Image: "flaticon-resume",
     
        heading: "3. Cross-Border Excellence",
        content: "We are specialists in navigating the legal, tax, and financial systems of both India and Canada. Our knowledge is deep, up-to-date, and grounded in real-world outcomes.",
    },
    {
        Image: "flaticon-expert-1",
      
        heading: "4. Empower Through Education",
        content: "We don’t just serve — we educate. Through webinars, resources, and personalized coaching, we empower NRIs to make informed decisions about their futures."
    },
    {
        Image: "flaticon-brainstorming",
        
        heading: "5. Ethical Action",
        content: "We hold ourselves to the highest ethical standards. We do what’s right, not just what’s easy — always acting in the best interest of our clients, partners, and communities."
    },
    {
        Image: "flaticon-active",
      
        heading: "6. Cultural Understanding",
        content: "We understand the emotions, expectations, and values tied to India for every NRI. Our work reflects a deep respect for both heritage and the realities of living abroad."
    },
]
const Servicesone = () => {
    return (
        <section className="services-section-one mt-5">
            {/* <div className="service-one-shape-1">
                <img src={Shape01} alt="shape" />
            </div>
            <div className="service-one-shape-2">
                <img src={Shape00} alt="shape" />
            </div> */}
            <div className="container ">
                {/* <div className="row">
                    <div className="col-lg-8 m-auto">
                        <div className="heading-box text-center">
                            <span className="heading-subtitle wow fadeInUp animated animated">
                                🤝 OUR SERVICES
                            </span>
                            <h2 className="heading-title wow fadeInUp animated animated mb-0 pb-0">
                            Local Expertise. Global Impact.
                            </h2>
                            <h6 className='mt-0 pt-0 mb-10 pb-5'>COMPREHENSIVE ARRAY OF SERVICES</h6>
                        </div>
                    </div>
                </div> */}
                <div className="service-one-inner1 ">
                    {Servicedata.map((data, index) => (
                        <div key={index} className="service-one-box1" style={{border: "1px solid #f2f4f8"}}>
                            {/* <div className="service-one-box-image">
                                <img
                                    src={data.bg} alt="service images"
                                />
                            </div> */}
                            <div className="service-one-icon-box">
                                {/* <img src={data.Image} className="flaticon-personal w-50 h-50 object-cover" alt="icon" /> */}
                                <i className={data.Image}/>
                            </div>
                            <div className="service-one-info1">
                                <h4>{data.heading}</h4>
                                <p>
                                    {data.content}
                                </p>
                            </div>
                            {/* <Link to="/Servicesdetails" className="read-more-btn">
                                <i className="flaticon-next" />
                            </Link> */}
                        </div>
                    ))}
                </div>
                {/* <div className="text-center">
                    <Link to="/Services1" className="btn btn-secondary">
                        View More
                        <i className="flaticon-personal" />
                    </Link>
                </div> */}
            </div>
        </section>

    )
}
export default Servicesone;